export const PREVIEW_DRAWER_EVENT_PREFIX = 'Gen_AI_Optimization_Drawer';
export const PREVIEW_DRAWER_MODE_PREFIXES = {
    REPLACE_BACKGROUND: 'Replace_Background',
    IMAGE_VARIATIONS: 'Image_Variations',
    MOTION_ADS: 'Motion_Ads',
};
